import { SortModelItem } from 'ag-grid-community';
import { RowHeights } from '@core/config/row-heights';
import { Project } from '@core/models/project.model';
import { Classification } from '@portal-shared/app/entities/class.model';
import { Department } from '@portal-shared/app/entities/department.model';
import { ViewByEnum } from '@portal-shared/app/enums/view-by.enum';
import { FormatUtils } from '@portal-shared/app/utils/format.utils';
import { StringUtils } from '@portal-shared/app/utils/string.utils';
import { ResourceAssignmentRowDto } from '@services/dtos/rows/resource-assignment-row.dto';
import { AssignmentDefinition } from '@services/models/assignment-definition.model';
import { ProjectService } from '@services/project.service';
import { AssignmentRowType } from '@shared/components/grids/rows/assignments/assignment-row-type.enum';
import { AssignmentRow } from './assignment-row';

export class ResourceAssignmentRow extends AssignmentRow {
  public override height = RowHeights.planningGrid.rowMedium;
  public override isRowDroppable = true;
  public override styleClasses = [`p-${this.dto.projectCode}`];

  public project: Project;
  public department: Department;
  public classification: Classification;

  public constructor(
    public dto: ResourceAssignmentRowDto,
    public resourceId: string
  ) {
    const type = ProjectService.isTimeoffProject(dto.projectId)
      ? AssignmentRowType.TimeOff
      : AssignmentRowType.Assignment;

    super(dto, dto.projectId, dto.departmentId, Classification.handleUndefinedClass(dto.classId), resourceId, type);

    this.project = new Project(dto.projectId, dto.projectCode, dto.projectIsActive, dto.projectDescription);
    this.department = new Department(dto.departmentId, dto.departmentCode ?? '', dto.departmentDescription);
    this.classification = new Classification(dto.classId, dto.classCode, dto.classDescription);
  }

  public override compare(rowB: ResourceAssignmentRow) {
    //  Compare by row type prioritys
    const rowTypePriorityCompare = rowB.rowTypePriority - this.rowTypePriority;
    if (rowTypePriorityCompare !== 0) {
      return rowTypePriorityCompare;
    }

    //Compare by project label
    return StringUtils.compareStrings(this.project.label, rowB.project.label);
  }

  public override toAssignmentDefinition(): AssignmentDefinition {
    return {
      projectId: this.project.id,
      departmentId: this.department.id,
      classId: this.classification.id,
      resourceId: this.resourceId
    };
  }

  public static getDefaultSortModel(): SortModelItem[] {
    const codeItem: SortModelItem = { colId: 'projectCode', sort: 'asc' };
    const descItem: SortModelItem = { colId: 'projectDescription', sort: 'asc' };

    switch (FormatUtils.viewBy) {
      case ViewByEnum.viewByCode:
        return [codeItem];
      case ViewByEnum.viewByDescription:
        return [descItem];
      case ViewByEnum.viewByCodeDescription:
        return [codeItem, descItem];
    }
  }
}
